
import { useState } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import { Tooltip as ReactTooltip } from "react-tooltip";
import logo from '../assets/img/codeflare-app.webp';
import js from '../assets/img/js.png';
import user from '../assets/img/user.png';
import { useSidebarContext } from "./SidebarCourseContext";
import Greet  from '../components/GreetUser';
import { Link } from "react-router-dom";
import { tokens } from "../theme";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SwitchRightOutlinedIcon from "@mui/icons-material/SwitchRightOutlined";
import SwitchLeftOutlinedIcon from "@mui/icons-material/SwitchLeftOutlined";
const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.white[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
      routerLink={<Link to={to} />}
    >

      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const JavaScriptCourseNav = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("");
  const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "5px 35px 5px 20px !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
        "& .menu-item.active": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
      }}
    >
      <Sidebar
        breakPoint="md"
        rtl={sidebarRTL}
        backgroundColor={colors.primary[200]}
        image={sidebarImage}
      >
        <Menu iconshape="square"
        menuItemStyles={{
        button: ({ level, active, disabled }) => {
          // only apply styles on first level elements of the tree
          return {
           color: disabled ? '#f5d9ff' : '#FFF',
           backgroundColor: active ? '#eecef9' : undefined,
           '&:hover': {
              backgroundColor: 'hsl(217, 28%, 15%)',
            },
         };
        },
      }}

        >
          <MenuItem
            icon={
              collapsed ? (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              ) : sidebarRTL ? (
                <SwitchLeftOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              ) : (
                <SwitchRightOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.blueAccent[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
              <img
                className="avater-image"
                alt="Codefussion"
                width="30%"
                height="auto"
                src={logo}
                style={{ cursor: "pointer", alignSelf: 'center' }}
              />
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: colors.primary[500],
                  },
                }}
              >
                <img
                  className="avater-image"
                  alt="profile user"
                  width="72px"
                  height="72px"
                  src={js}
                  style={{ cursor: "pointer" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.white[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  style={{ textAlign: 'center' }}
                >
                  {/*<Greet /> */}
                  <h3 className="text-light">JavaScript</h3>
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={collapsed ? undefined : "1%"}>

            <MenuItem className={window.location.href.toString().includes("dashboard") ? 'active' : ''} icon={<HomeOutlinedIcon />} component={<Link to="/dashboard" />}>Go to Dashbord</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-course-outline") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-course-outline" />}>Course outline</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-introduction") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-introduction" />}>1. Introduction to JavaScript</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-standards") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-standards" />}>2. Standardization of JavaScript</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-setup") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-setup" />}>3. Setup JavaScript</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-placement") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-placement" />}>4. Placement of JavaScript</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-terminal") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-terminal" />}>5. Run JavaScript from Terminal</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-variable-type") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-variable-type" />}>6. Variables</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-declaration") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-declaration" />}>7. Variable Declaration</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-variable-hoisting") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-variable-hoisting" />}>8. Hoisting</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-variable-scope") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-variable-scope" />}>9. Variable Scope</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-variable-namingconvention") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-variable-namingconvention" />}>10. Variable Naming Conventions</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-reserved-words") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-reserved-words" />}>11. Reserved Words</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-operators") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-operators" />}>12. Operators</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-types-of-operator") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-types-of-operator" />}>13. Types of Operators</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-data-types") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-data-types" />}>14. Data Types</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-functions") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-functions" />}>15. Functions</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-controlstructures") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-controlstructures" />}>16. Control Structures</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-loops") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-loops" />}>17. Loops</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-arrays") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-arrays" />}>18. Arrays</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-rest-parameters") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-rest-parameters" />}>19. Rest Parameters</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-object") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-object" />}>20. Objects</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-recursive-functions") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-recursive-functions" />}>21. Recursions</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-oriented-programming") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-oriented-programming" />}>22. Object Oriented Programming</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-string-methods") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-string-methods" />}>23. String Methods</MenuItem>
            <MenuItem data-tooltip-id="callback" className={window.location.href.toString().includes("javascript-callbacks") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-callbacks" />}>24. Callbacks, Promises, Async / await</MenuItem>
            <MenuItem data-tooltip-id="api" className={window.location.href.toString().includes("javascript-api") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-api" />}>25. API</MenuItem>
            <MenuItem data-tooltip-id="ajax" className={window.location.href.toString().includes("javascript-ajax") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-ajax" />}>26. AJAX Methodology</MenuItem>
            <MenuItem className={window.location.href.toString().includes("javascript-reqres") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/javascript-reqres" />}>27. Reqres</MenuItem>
            <ReactTooltip
            id="callback"
            place="top"
            content="Callbacks, Promises, Async / await"
            />
            <ReactTooltip
            id="api"
            place="top"
            content="API"
            />

          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default JavaScriptCourseNav;
